import { render } from "./TheHeader.vue?vue&type=template&id=4c0d295c&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2696572544/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__